
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.01 11.315a.655.655 0 100-1.31 3.931 3.931 0 113.931-3.931v1.31a.655.655 0 11-1.31 0v-1.31a2.62 2.62 0 10-2.621 2.62 2.62 2.62 0 001.5-.478 1.966 1.966 0 003.741-.832v-1.31a5.241 5.241 0 10-5.241 5.241zm0-3.93a1.31 1.31 0 110-2.622 1.31 1.31 0 010 2.621v0zm8.917.792l-1.965-1.514a.655.655 0 00-.8 1.036l1.31.995-7.462 5.727-7.443-5.727 1.31-.995a.66.66 0 10-.819-1.036L1.092 8.177a.655.655 0 00-.255.517v8.518a1.966 1.966 0 001.966 1.966h14.414a1.966 1.966 0 001.966-1.966V8.694a.656.656 0 00-.256-.517zm-1.71 9.69H2.803a.656.656 0 01-.656-.655v-7.207l7.463 5.74a.655.655 0 00.8 0l7.462-5.74v7.207a.655.655 0 01-.655.655z","fill":"#374151","stroke":"#374151","stroke-width":".25"}})])
          )
        }
      }
    